export enum Granularity {
  MONTH = 'MONTH',
  DAY = 'DAY',
  HOUR = 'HOUR'
}

export enum ProductType {
  ELECTRICITY = 'electricity',
  GAS = 'gas'
}
